import {createTheme} from '@material-ui/core/styles'
import grey from '@material-ui/core/colors/grey'

import './types'
import {
  black,
  white,
  black90,
  greyL,
  greyUL,
  greyUL2,
  greyM,
  greyD,
  blackM,
  blueL,
  success,
  errorL,
  error,
  errorD,
  warning,
  warningL,
  info,
  blueTransparent,
  whiteTransparent,
  amberTransparent3,
  amberTransparent4,
  amberM,
  blackTransparent,
  blueUL,
  blueUL2,
  greyUL1,
  amberS,
  transparent,
  blueM,
} from './colors'

const theme = createTheme({
  filterPanelWidth: 400,
  filterHeaderHeight: 50,
  sidebarCloseWidth: 72,
  headerHeight: 64,
  primarySb: grey[900],
  primarySbSelected: black,
  drawerWidth: 275,
  drawerMapWidth: 326,
  headerMapHeight: 55,
  zIndex: {
    popupLoader: 1,
    appBar: 200,
    drawer: 100,
    parts: 90,
  },
  gridGup: {
    main: 24,
  },
  palette: {
    success: {
      main: success,
    },
    error: {
      light: errorL,
      main: error,
      dark: errorD,
    },
    warning: {
      light: warningL,
      main: warning,
    },
    info: {
      main: info,
    },
    sidebar: {
      active: amberM,
      main: white,
      bgMain: black90,
      bgActive: black,
    },
    customGrey: {
      lightUL: greyUL,
      lightUL1: greyUL1,
      lightUL2: greyUL2,
      light: greyL,
      middle: greyM,
      dark1: greyD,
      dark: grey[600],
    },
    amber: {
      light: amberS,
      middle: amberM,
    },
    blue: {
      lightUL: blueUL,
      lightUL2: blueUL2,
      middle: blueL,
      middle2: blueM,
    },
    white,
    black,
    black90,
    blackM,
    transparent,
    blueTransparent,
    whiteTransparent,
    amberTransparent3,
    amberTransparent4,
    blackTransparent,
    primary: {main: blueL, contrastText: white},
  },
})
export default theme
